module.exports = __webpack_public_path__ + "assets/img/NPC034.ee8fd47e.png";